import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  ReportList,
  ReportSetup,
  RealTimeReport,
  DashboardSettings
} from 'views/index';

const prefixes = {
  reports: 'reports',
  dashboards: 'dashboards'
};
const ReportRoutes = () => (
  <Switch>
    <Route
      path={`/${prefixes.reports}/:reportId/real-time/:action`}
      component={RealTimeReport}
    />
    <Route
      path={`/${prefixes.reports}/report-setup/:objectType/:reportId`}
      component={ReportSetup}
    />
    <Route
      path={`/${prefixes.reports}/dashboard-setup/:dashboardId`}
      component={ReportSetup}
    />
    <Route path={`/${prefixes.reports}/list`} component={ReportList} />
    {/* Route used to create dashboard setting in folder */}
    <Route
      path={`/dashboardFolders/:dashboardFolderId/${
        prefixes.dashboards
      }/:dashboardId/settings`}
      component={DashboardSettings}
    />
    {/* Route simple display dashboard settings */}
    <Route
      path={`/${prefixes.dashboards}/:dashboardId/settings`}
      component={DashboardSettings}
    />
    <Redirect from={`/${prefixes.reports}`} to={`/${prefixes.reports}/list`} />
  </Switch>
);

export default ReportRoutes;



// WEBPACK FOOTER //
// ./src/components/page/MainContent/components/ReportRoutes.jsx